import { render, staticRenderFns } from "./organization_table.vue?vue&type=template&id=6c124bd0&scoped=true"
import script from "./organization_table.vue?vue&type=script&lang=js"
export * from "./organization_table.vue?vue&type=script&lang=js"
import style0 from "./organization_table.vue?vue&type=style&index=0&id=6c124bd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c124bd0",
  null
  
)

export default component.exports